module.exports = __webpack_public_path__ + "static/media/design4.337bdd72.jpg";